import { Component, EventEmitter, Input, OnInit, Output, OnChanges, ViewChild } from '@angular/core';
import { CreditsQuestionsService } from '../credits-questions.service';
import { DynamicFormComponent } from 'core/components/forms/dynamic-form.component';
import { Client } from 'core/models/client';
import { Subscription } from 'core/models/subscription';
import { SubscriptionsService } from 'core/services/subscriptions.service';

@Component({
  selector: 'lms-credit-editor',
  templateUrl: './credit-editor.component.html',
  styleUrls: ['./credit-editor.component.scss']
})
export class CreditEditorComponent implements OnInit, OnChanges {
  @Input() subscription: Subscription;
  @Input() client: Client;
  @Output() saved = new EventEmitter<Subscription>();
  @ViewChild(DynamicFormComponent, { static: false }) public dynamicForm: DynamicFormComponent;
  public questions: any[];

  constructor(public subscriptionsService: SubscriptionsService, public creditsQuestions: CreditsQuestionsService) {}

  ngOnInit() {}

  ngOnChanges() {
    this.questions = this.creditsQuestions.getQuestions(this.subscription, this.client);
  }

  submit(subscriptionData: any) {
    if (this.subscription) {
      this.onUpdate(subscriptionData);
    } else {
      this.onCreate(subscriptionData);
    }
  }

  onCreate(subscriptionData: Object) {
    this.subscriptionsService
      .create(subscriptionData)
      .then((creditsBag) => {
        this.saved.emit(creditsBag);
        this.endSubmit(null);
      })
      .catch((err) => {
        this.endSubmit(err);
      });
  }

  onUpdate(updatedData: Object) {
    const updatedSubscription: Subscription = Object.assign({}, this.subscription, updatedData);
    this.subscriptionsService
      .update(updatedSubscription)
      .then((subscription) => {
        this.saved.emit(subscription);
        this.endSubmit(null);
      })
      .catch((err) => {
        this.endSubmit(err);
      });
  }

  endSubmit(value) {
    this.dynamicForm.submitted(value);
  }
}
